import React from "react";
import * as Style from "../../styles/components/blocks/cookies.module.scss";
import { useOutsideClick } from "../../scripts/useClickOutside";
import eventBus from "../../utils/eventBus";

const Cookies = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [areCookies, setAreCookies] = React.useState(false);
  const [cookies, setCookies] = React.useState(null);
  const [isScript, setIsScript] = React.useState(false);
  const modale = React.useRef(null);

  useOutsideClick(modale, () => {
    if (isOpen) setIsOpen(false);
  });

  const handleCookies = (state) => {
    if (state) {
      setCookies({ username: "a" });
    }else{
      setCookies(null)
    }

    setCookies((value) => {
      if (value) {
        localStorage.setItem("areAcceptedCookies", "true");
        setAreCookies(true);
      } else {
        localStorage.setItem("areAcceptedCookies", "false");
      }
      setIsOpen(false);
      eventBus.dispatch("cookieChanged", { value: value });
      return value;
    });
  };

  const manageGoogleHeadScript = () => {
    const headScript = document.querySelector(
      'script[data-head-script="true"]'
    );
    console.log("Manage");
    if (localStorage.getItem("areAcceptedCookies") === "true" && !headScript) {
      console.log(localStorage.getItem("areAcceptedCookies"));
      // Créez un élément script
      let headScript = document.createElement("script");
      headScript.setAttribute("data-head-script", "true");
      headScript.innerHTML = `
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MH6HWKR7');
      `;
      // Ajoutez le script au head de la page
      document?.head?.appendChild(headScript);
      // let bodyScript = document.createElement("noscript");
      // bodyScript.setAttribute("data-body-script", true);
      // bodyScript.innerHTML = `<noscript><iframe src=https://www.googletagmanager.com/ns.html?id=GTM-MH6HWKR7 height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
      // document?.body?.appendChild(bodyScript);
    } else if (
      localStorage.getItem("areAcceptedCookies") === "false" &&
      headScript
    ) {
      // Retirez le script secondaire
      let headScript2 = document.querySelector(
        '[src="https://www.googletagmanager.com/gtm.js?id=GTM-MH6HWKR7"]'
      );
      if (headScript) {
        headScript?.remove();
        headScript2?.remove();
      }
    }
  };
  const manageGoogleBodyScript = () => {
    const bodyScript = document.querySelector(
      'script[data-body-script="true"]'
    );

    if (localStorage.getItem("areAcceptedCookies") === "true" && !bodyScript) {
      // Créez un élément script
      let bodyScript = document.createElement("noscript");
      bodyScript.setAttribute("data-body-script", "true");

      bodyScript.innerHTML = `
      <noscript><iframe src=https://www.googletagmanager.com/ns.html?id=GTM-MH6HWKR7 height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
      `;

      // Ajoutez le script au head de la page
      document?.body?.appendChild(bodyScript);
      // let bodyScript = document.createElement("noscript");
      // bodyScript.setAttribute("data-body-script", true);
      // bodyScript.innerHTML = `<noscript><iframe src=https://www.googletagmanager.com/ns.html?id=GTM-MH6HWKR7 height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
      // document?.body?.appendChild(bodyScript);
    } else if (
      localStorage.getItem("areAcceptedCookies") === "false" &&
      bodyScript
    ) {
      if (bodyScript) {
        bodyScript?.remove();
      }
    }
  };

  React.useEffect(() => {
    manageGoogleHeadScript();
    manageGoogleBodyScript();
  }, [cookies]);

  React.useEffect(() => {
    if (!localStorage.getItem("areAcceptedCookies")) {
      setIsOpen(true);
    } else {
      setCookies(localStorage.getItem("areAcceptedCookies"));
      setAreCookies(true);
    }
  }, []);

  return (
    <>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className={`${Style.bi_cookies}`}
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 20.025C8.61667 20.025 7.31667 19.7623 6.1 19.237C4.88333 18.7117 3.825 17.9993 2.925 17.1C2.025 16.2 1.31267 15.1417 0.788 13.925C0.263333 12.7083 0.000666667 11.4083 0 10.025C0 8.775 0.241667 7.55 0.725 6.35C1.20833 5.15 1.88333 4.079 2.75 3.137C3.61667 2.19567 4.65833 1.43733 5.875 0.862001C7.09167 0.286668 8.425 -0.000665509 9.875 1.15741e-06C10.225 1.15741e-06 10.5833 0.0166679 10.95 0.0500012C11.3167 0.0833346 11.6917 0.141668 12.075 0.225001C11.925 0.975001 11.975 1.68333 12.225 2.35C12.475 3.01667 12.85 3.57067 13.35 4.012C13.85 4.454 14.446 4.75833 15.138 4.925C15.83 5.09167 16.5423 5.05 17.275 4.8C16.8417 5.78333 16.9043 6.725 17.463 7.625C18.0217 8.525 18.8507 8.99167 19.95 9.025C19.9667 9.20833 19.9793 9.379 19.988 9.537C19.9967 9.695 20.0007 9.866 20 10.05C20 11.4167 19.7373 12.704 19.212 13.912C18.6867 15.12 17.9743 16.1783 17.075 17.087C16.175 17.9957 15.1167 18.7123 13.9 19.237C12.6833 19.7617 11.3833 20.0243 10 20.025ZM8.5 8.025C8.91667 8.025 9.271 7.879 9.563 7.587C9.855 7.295 10.0007 6.941 10 6.525C10 6.10833 9.854 5.754 9.562 5.462C9.27 5.17 8.916 5.02433 8.5 5.025C8.08333 5.025 7.729 5.171 7.437 5.463C7.145 5.755 6.99933 6.109 7 6.525C7 6.94167 7.146 7.296 7.438 7.588C7.73 7.88 8.084 8.02567 8.5 8.025ZM6.5 13.025C6.91667 13.025 7.271 12.879 7.563 12.587C7.855 12.295 8.00067 11.941 8 11.525C8 11.1083 7.854 10.754 7.562 10.462C7.27 10.17 6.916 10.0243 6.5 10.025C6.08333 10.025 5.729 10.171 5.437 10.463C5.145 10.755 4.99933 11.109 5 11.525C5 11.9417 5.146 12.296 5.438 12.588C5.73 12.88 6.084 13.0257 6.5 13.025ZM13 14.025C13.2833 14.025 13.521 13.929 13.713 13.737C13.905 13.545 14.0007 13.3077 14 13.025C14 12.7417 13.904 12.504 13.712 12.312C13.52 12.12 13.2827 12.0243 13 12.025C12.7167 12.025 12.479 12.121 12.287 12.313C12.095 12.505 11.9993 12.7423 12 13.025C12 13.3083 12.096 13.546 12.288 13.738C12.48 13.93 12.7173 14.0257 13 14.025ZM10 18.025C12.0333 18.025 13.8377 17.325 15.413 15.925C16.9883 14.525 17.8507 12.7417 18 10.575C17.1667 10.2083 16.5123 9.70834 16.037 9.075C15.5617 8.44167 15.241 7.73333 15.075 6.95C13.7917 6.76667 12.6917 6.21667 11.775 5.3C10.8583 4.38333 10.2917 3.28333 10.075 2C8.74167 1.96667 7.57067 2.20833 6.562 2.725C5.55333 3.24167 4.712 3.90433 4.038 4.713C3.362 5.521 2.853 6.4 2.511 7.35C2.169 8.3 1.99867 9.19167 2 10.025C2 12.2417 2.779 14.1293 4.337 15.688C5.895 17.2467 7.78267 18.0257 10 18.025Z"
            fill="#3A3636"
          />
        </svg>
      </button>
      {isOpen && (
        <div ref={modale} className={`${Style.bi_cookies_panel}`}>
          <p>
            Le stockage ou l’accès technique est nécessaire pour créer des
            profils d’utilisateurs afin d’envoyer des publicités, ou pour suivre
            l’utilisateur sur un site web ou sur plusieurs sites web à des fins
            de marketing similaires.
          </p>
          <div>
            <button onClick={() => handleCookies(true)}>
              <p>Accepter</p>
            </button>
            <button onClick={() => handleCookies(false)}>
              {<p>Refuser</p>}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Cookies;
